module.exports = __webpack_public_path__ + "img/album09_04.76d0ac2e.jpg";